import React, { useEffect, useState, lazy } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { PhoneIcon, MapPinIcon, ClockIcon, ArrowUpIcon, FacebookIcon, InstagramIcon, LinkedinIcon, TwitterIcon } from 'lucide-react';
import { COMPANY, NAV_LINKS, SERVICES } from '../lib/site';
import { WaveDivider } from './fx/WaveDivider';
export function Footer() {
  const [showTop, setShowTop] = useState(false);
  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const socials = [FacebookIcon, InstagramIcon, LinkedinIcon, TwitterIcon];
  return <footer className="relative mt-20" data-id="element-41" data-mp="29z6vif77cphh">
      <WaveDivider color="#EAF5FF" data-id="element-42" data-mp="29y5frxf8retf" />
      <div className="bg-sky" data-id="element-43" data-mp="2a19vns22jyzx">
        <div className="mx-auto max-w-7xl px-6 py-16" data-id="element-44" data-mp="2ey05hxna5ycw">
          <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4" data-id="element-45" data-mp="2ezl5i2sd69i5">
            <div data-id="element-46" data-mp="3lalg1f31y5ty">
              <div className="flex items-center gap-3" data-id="element-47" data-mp="3la27uq37evt4">
                <motion.img src={COMPANY.logo} alt="" loading="lazy" decoding="async" className="h-14 w-14 object-contain" animate={{
                filter: ['drop-shadow(0 0 0 rgba(0,87,255,0))', 'drop-shadow(0 0 14px rgba(0,87,255,0.4))', 'drop-shadow(0 0 0 rgba(0,87,255,0))']
              }} transition={{
                duration: 4,
                repeat: Infinity
              }} data-id="element-48" data-mp="3gaz2t5n84pl5" />
                <span className="font-display text-lg font-bold text-navy" data-id="element-49" data-mp="cuikg7p7s7lz">
                  Dream Shield
                </span>
              </div>
              <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate" data-id="element-50" data-mp="msg7irvc7yd0">
                Premium restoration & construction serving {COMPANY.serviceArea}
                . We restore homes and protect families — 24/7.
              </p>
              <div className="mt-5 flex gap-3" data-id="element-51" data-mp="yupja3t46wdi">
                {socials.map((Icon, i) => <motion.a key={i} href="#" aria-label="Social link" whileHover={{
                y: -4,
                scale: 1.1
              }} className="flex h-10 w-10 items-center justify-center rounded-full bg-white text-royal shadow-glass transition-colors hover:bg-royal hover:text-white" data-id="element-52" data-mp="13rps2mhcmd8b" data-mpi={i}>
                    <Icon className="h-4 w-4" data-id="element-53" data-mp="1riv56tvwmrex" />
                  </motion.a>)}
              </div>
            </div>

            <div data-id="element-54" data-mp="3obx2lev1v0vx">
              <h4 className="font-display text-sm font-bold uppercase tracking-wider text-navy" data-id="element-55" data-mp="3ocgh0llhr757">
                Quick Links
              </h4>
              <ul className="mt-4 space-y-2.5" data-id="element-56" data-mp="2af3r7lrdkvhi">
                {NAV_LINKS.map(link => <li key={link.to} data-id="element-57" data-mp="2agygfc9oj9re">
                    <Link to={link.to} className="text-sm text-slate transition-colors hover:text-royal" data-id="element-58" data-mp="25o57ec76hf9i">
                      {link.label}
                    </Link>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-59" data-mp="2tcyacsm7wndm">
              <h4 className="font-display text-sm font-bold uppercase tracking-wider text-navy" data-id="element-60" data-mp="2tdg33f9o8jgs">
                Services
              </h4>
              <ul className="mt-4 space-y-2.5" data-id="element-61" data-mp="2kdb51vqdaxfa">
                {SERVICES.slice(0, 8).map(s => <li key={s.slug} data-id="element-62" data-mp="2fegpr3rlzqzx">
                    <Link to={`/services/${s.slug}`} className="text-sm text-slate transition-colors hover:text-royal" data-id="element-63" data-mp="2fd5d0eg6r8wo">
                      {s.title}
                    </Link>
                  </li>)}
              </ul>
            </div>

            <div data-id="element-64" data-mp="2ru6ahipi4teb">
              <h4 className="font-display text-sm font-bold uppercase tracking-wider text-navy" data-id="element-65" data-mp="2rtmxmgepkv75">
                Emergency Contact
              </h4>
              <ul className="mt-4 space-y-4 text-sm text-slate" data-id="element-66" data-mp="2iw456qyqjel8">
                <li data-id="element-67" data-mp="2nu5pff7wdjya">
                  <a href={COMPANY.phoneHref} className="flex items-center gap-3 font-semibold text-navy transition-colors hover:text-fire" data-id="element-68" data-mp="2ntcpax3g1sp4">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-fire/10 text-fire" data-id="element-69" data-mp="3fllj1t7vg6y0">
                      <PhoneIcon className="h-4 w-4" data-id="element-70" data-mp="31khk9lvv9wt4" />
                    </span>
                    {COMPANY.phoneDisplay}
                  </a>
                </li>
                <li className="flex items-center gap-3" data-id="element-71" data-mp="1q6nepyuoe7rn">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-royal/10 text-royal" data-id="element-72" data-mp="1q52k698d2ots">
                    <MapPinIcon className="h-4 w-4" data-id="element-73" data-mp="1v3dxwv1s1jha" />
                  </span>
                  {COMPANY.location}
                </li>
                <li className="flex items-center gap-3" data-id="element-74" data-mp="1ine8gehgup6t">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-success/10 text-success" data-id="element-75" data-mp="1ioyzvv8hhs0g">
                    <ClockIcon className="h-4 w-4" data-id="element-76" data-mp="1rnjd4gv9z9ha" />
                  </span>
                  24/7 Emergency Response
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-royal/10 pt-6 text-xs text-slate md:flex-row" data-id="element-77" data-mp="13vm1oqvqmjgp">
            <p data-id="element-78" data-mp="1doth74k6zfui">
              © {new Date().getFullYear()} {COMPANY.fullName}. All rights
              reserved.
            </p>
            <p data-id="element-79" data-mp="18vqkink4bqa3">Licensed • Insured • IICRC Certified</p>
          </div>
        </div>
      </div>

      <AnimatePresence data-id="element-80" data-mp="l5w6i2o2bvo9">
        {showTop && <motion.button initial={{
        opacity: 0,
        scale: 0.6
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.6
      }} whileHover={{
        y: -4
      }} onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} aria-label="Back to top" data-cursor="button" className="fixed bottom-6 right-6 z-[400] flex h-12 w-12 items-center justify-center rounded-full bg-royal text-white shadow-glow" data-id="element-81" data-mp="g8nsme9y6dst">
            <ArrowUpIcon className="h-5 w-5" data-id="element-82" data-mp="278w28w6cre5v" />
          </motion.button>}
      </AnimatePresence>
    </footer>;
}